import AppBar from '@material-ui/core/AppBar';
import AsyncSelect from 'react-select/async';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import ReactTable from 'react-table';

import { CircularProgress } from '@material-ui/core';

function getStateFromHash() {
    const text = window.location.hash;
    if (!text) {
        return {};
    }
    return JSON.parse(decodeURIComponent(text.substring(1)));
}

function setStateToHash(value) {
    window.location.hash = encodeURIComponent(JSON.stringify(value));
}

function BanView(props) {
    function ban(value) {
        fetch('/api/data/comment/hide', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: props.id,
                hide: value,
            }),
        }).then(() => {
            props.onUpdate();
        });
    }
    if (props.banned) {
        return (<div>
            true&nbsp;
            <Button onClick={() => ban(false)}>Unban</Button>
        </div>);
    }
    return (<div>
        false&nbsp;
        <Button onClick={() => ban(true)}>Ban</Button>
    </div>);
}

BanView.propTypes = {
    id: PropTypes.string.isRequired,
    banned: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
};

export class MapComments extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            error: null,
            query: getStateFromHash().comments_query || JSON.stringify({ 'user_id': this.props.userId }, null, 4),
        };

        this.MapCommentColumns = [
            {
                id: "hide",
                // eslint-disable-next-line react/display-name
                accessor: row => <BanView id={row._id} banned={!!row.hide} onUpdate={this.onRefresh} />,
                Header: "Hide",
                width: 150,
            },
            {
                Header: "Map Key",
                accessor: "map_key",
                width: 150,
            },
            {
                id: "user_id",
                Header: "User Id",
                // eslint-disable-next-line react/display-name
                accessor: row => <a href={`/user/${row.user_id}`}>{row.user_id}</a>,
                width: 350,
            },
            {
                Header: "Name",
                accessor: "name",
                width: 150,
            },
            {
                Header: "Time",
                accessor: "time",
                width: 200,
            },
            {
                accessor: 'content',
                Header: "Content",
            }
        ];
    }

    componentDidUpdate() {
        const data = getStateFromHash();
        data.comments_query = this.state.query;
        setStateToHash(data);
    }

    handleTextField = name => event => {
        this.setState({ [name]: event.target.value });
    }

    componentDidMount() {
        this.startRequest();
    }

    onRefresh = () => {
        this.setState({ loading: true, error: null, data: null });
        this.startRequest();
    }

    startRequest() {
        fetch(`/api/data/search/map_comment`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: eval(`(${this.state.query})`), sort: { time: -1 } }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, data: result.results });
                }
            });
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        let valid = true;
        let reason = '';
        if (this.state.error) {
            valid = false;
            reason = reason || this.state.error;
        }
        try {
            const query = eval(`(${this.state.query})`);
            if (typeof query !== 'object') {
                valid = false;
                reason = reason || 'Expecting an object instead of ' + (typeof query) + ': ' + this.state.query;
            }
        } catch (err) {
            valid = false;
            reason = reason || err.message;
        }
        console.log(this.state.data);
        return (
            <div>
                <div>
                    <b>Make sure your query includes at least one of the indexed keys: map_key, user_id, time, likes. If not your query will be very slow.</b>
                </div>
                {!valid && <div style={{ color: 'red' }}>{reason}</div>}
                <textarea rows={10} cols={50} value={this.state.query} onChange={this.handleTextField('query')} />
                <Button onClick={this.onRefresh} disabled={!valid}>Refresh</Button>

                <ReactTable
                    className="-striped -highlight"
                    columns={this.MapCommentColumns}
                    pageSize={this.state.data.length}
                    showPagination={false}
                    data={this.state.data}
                />
            </div>
        );
    }
}

MapComments.propTypes = {
    userId: PropTypes.string,
};
